<template>
  <div class="field">
    <label class="label" v-if="to.label" :for="to.id ? to.id : null">{{
      to.label
    }}</label>
    <div class="control has-icons-right mt-2">
      <input
        :class="['input', { 'is-danger': hasError }, to.classes]"
        :id="to.id ? to.id : null"
        v-model="model[field.key]"
        :name="field.key"
        @blur="onBlur"
        @focus="onFocus"
        @click="onClick"
        @change="onChange"
        @keyup="onKeyup"
        @keydown="onKeydown"
        v-formly-atts="to.atts"
        v-formly-input-type="to.inputType"
      />

      <span class="icon is-small is-right" v-if="hasError">
        <i class="fa fa-warning"></i>
      </span>
    </div>
    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import baseField from "./baseField";

export default {
  mixins: [baseField],
  methods: {
    onChange(e) {
      this.$set(this.form[this.field.key], "$dirty", true);
      this.runFunction("onChange", e);
      if (this.to.inputType === "file") {
        this.$set(
          this.model,
          this.field.key,
          this.$el.querySelector("input").files
        );
      }
    }
  }
};
</script>
